import { CrmCard } from './crm-card'
export { CrmCard }
